export default __webpack_public_path__ + "static/media/Ct5.61946945.png";